module.exports = __webpack_public_path__ + "static/media/team.30c09729.JPG";